"use client";

import { usePathname } from "next/navigation";
import { Suspense, useEffect, useState } from "react";

function Li() {
  const [name, setName] = useState("");
  const pathname = usePathname();
  const lastPath = pathname.split("/").filter(Boolean).at(-1) || "";

  useEffect(() => {
    const h2 = document.querySelector("h2");
    if (h2) {
      setName(h2.textContent || "");
    }
  }, []);

  return (
    <li>
      {name}
      {lastPath === "bat" ? "（打撃成績）" : "（投手成績）"}
    </li>
  );
}

export function LiPlayerName() {
  return (
    <Suspense fallback={<li>--------</li>}>
      <Li />
    </Suspense>
  );
}
